import { gsap } from '../global/gsap';

const initScrollButtons = (buttons) => {
    const handleScroll = (button, target, offset) => {
        if (target === 'next') {
            target = button.closest('section').nextElementSibling;
        }

        gsap.to(window, {
            scrollTo: {
                y: target,
                offsetY: offset,
                autoKill: true
            },
            duration: 0.6,
            ease: 'power3.inOut'
        });
    };

    buttons.forEach((button) => {
        // Target fall back to <a href> if data-target not set
        const target = button.dataset.target ? button.dataset.target : `#${button.hash.substr(1)}`;
        const offset = button.dataset.offset ? button.dataset.offet : 0;

        if (target) {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                handleScroll(button, target, offset);
            });
        }
    });
};

export default initScrollButtons;
